import React from 'react';
import {
  RadialBarChart,
  RadialBar,
  ResponsiveContainer,
  PolarAngleAxis,
  Tooltip,
} from 'recharts';
import dash from 'assets/icons/indeterminate.svg';
import CardFilters from 'components/specific/CardFilters';
import { AppIcon } from '@common';
import { crossIcon } from '@src/assets/svg';

const TerminationChart = ({
  title,
  value,
  maxValue,
  state,
  dispatch,
  date,
  check,
}) => {
  const percentage = (value / maxValue) * 100; // Convert to percentage
  const data = [{ name: 'Terminated', value: percentage, fill: '#D7233E' }]; // Red Color

  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
      return (
        <div className="bg-white text-gray-700 p-2 rounded-md shadow-md">
          <p className="text-sm font-semibold">{`${payload[0].value.toFixed(1)}%`}</p>
          <p className="text-xs">{`${value} / ${maxValue} contracts`}</p>
        </div>
      );
    }
    return null;
  };

  return (
    <div className="bg-red-100 shadow-md rounded-[20px] min-h-[464px] h-[100%] p-4">
      <div
        className="flex justi
      fy-between item-center"
      >
        <h2 className="text-md font-semibold text-red-700 flex items-center">
          <span className="text-lg mr-2">
            <img src={dash} alt="dash" />
          </span>{' '}
          {title}
        </h2>

        <CardFilters />
      </div>

      {Object.entries(state[1]?.selectedList).length > 0 ? (
        <span className="ml-6 !bg-gray-200 text-grey-600   px-0.5	">
          <span className="dashboardFilters--showcase--selectedFilters--item--value">
            {state[1].title === 'Date'
              ? Object.values(state[1].selectedList || {}).join(',')
              : Object.keys(state[1].selectedList || {}).join(',')}
          </span>
          <AppIcon
            icon={crossIcon}
            onClick={() => {
              if (state[1].title === 'Date') {
                date.removeDate();
              }
            }}
            className="dashboardFilters--showcase--selectedFilters--item--icon"
          />
        </span>
      ) : (
        console.log('state-have is empty', state[1])
      )}

      <hr className="border-red-200 my-2" />

      <div className="flex flex-col items-center">
        <div className="bg-red-100 p-10 rounded-lg w-full flex flex-col items-center">
          <ResponsiveContainer width="100%" height={400}>
            <RadialBarChart
              innerRadius="70%"
              outerRadius="140%" // Increased size
              startAngle={180}
              endAngle={0}
              barSize={35} // Thicker Arc
              data={data}
            >
              <PolarAngleAxis
                type="number"
                domain={[0, 100]}
                angleAxisId={0}
                tick={false}
              />
              <RadialBar
                background={{
                  fill: '#EDEDF5',
                  stroke: 'white',
                  strokeWidth: 3,
                }} // Light Gray Background
                dataKey="value"
                cornerRadius={0}
                stroke="white" // White border
                strokeWidth={3}
              />
              <Tooltip content={<CustomTooltip />} />
            </RadialBarChart>
          </ResponsiveContainer>

          <div className="text-center mt-[-230px]">
            <p className="text-5xl font-bold text-gray-800">{value}</p>
            <p className="text-lg text-gray-600">CONTRACT TERMINATED</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TerminationChart;
